import React, { Component } from 'react';
import  {RedPageComponent} from './RedPageComponent.js';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'universal-cookie';

class RedPage extends React.Component {

    state = {
       
      
        big_img_src : 'https://storage.yandexcloud.net/tgsubsphotos/g4x4FGp5ZX9gmEDmgvXSHe4PWu8g9PuEtcf2f2ibDoXDQ4Wd7J.jpg',
        small_img_src : 'https://storage.yandexcloud.net/tgsubsphotos/d5nLKFUyTM45w4a6OICxMAvurLshV6XSf5nmIBGMmaxmHIC60f.jpg',
        selected_file : null,
        prize : 'Спасибо за подписку! Ссылка на полезный материал [link]https://drive.google.com/file/d/1cVwT42N9_r8GuZmMWaKzommdYy4DBsYu/view?usp=sharing [/link]',
        header_text : 'Как во время кризиса заработать на криптовалютах? Топ 4 способа для каждого!',
        main_text : 'Наш телеграм канал специализируется на рынке криптовалют. За подписку на нас мы подарим полезный материал, в котором собрали и проанализировали разные способы заработать на криптовалютах прямо сейчас!',
        btnText : 'Подписаться'
    }

    constructor(props) {
        super(props);
       
        this.handleInputChange_smallImg = this.handleInputChange_smallImg.bind(this);
        this.handleInputChange_bigImg = this.handleInputChange_bigImg.bind(this);
        this.doSave = this.doSave.bind(this)
        this.updatePrize = this.updatePrize.bind(this)
        this.updateHeader = this.updateHeader.bind(this)
        this.updateMain = this.updateMain.bind(this)
    }


    handleInputChange_bigImg(event) {
        
        this.setState({
            selectedFile: event.target.files[0],
          }, () => {
            const data = new FormData() 
            data.append('file', this.state.selectedFile)
            console.warn(this.state.selectedFile);
            
            const cookies = new Cookies();
            
            axios.post(process.env.REACT_APP_BACKEND_SERVER + '/UploadImg/',
                 data, {
                    headers: {
                        'Authorization': 'Bearer '+cookies.get('tgsubs_token')
                    } // receive two parameter endpoint url ,form data 
            })
            .then(res => { // then print response status
                 
                this.setState({
                    big_img_src: res.data.link
                  }, () => {})
            })
          })

    }


    handleInputChange_smallImg(event) {
        
        this.setState({
            selectedFile: event.target.files[0],
          }, () => {
            const data = new FormData() 
            data.append('file', this.state.selectedFile)
            console.warn(this.state.selectedFile);
            
            const cookies = new Cookies();
            axios.post(process.env.REACT_APP_BACKEND_SERVER + '/UploadImg/',
                 data, {
                    headers: {
                        'Authorization': 'Bearer '+cookies.get('tgsubs_token')
                    }     // receive two parameter endpoint url ,form data 
            })
            .then(res => { // then print response status
                 
                this.setState({
                    small_img_src: res.data.link
                  }, () => {})
            })
          })

    }


    updatePageName = (e) => {
        const updatedInputValue = e.target.value;
        
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    page_name : updatedInputValue,
                    
                
                };
        }, () =>  {
            
        })
    
    }

    updateChannelName = (e) => {
        const updatedInputValue = e.target.value;
        
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    channel_name : updatedInputValue,
                    
                
                };
        }, () =>  {
            
        })
    
    }
    
    
    CheckIntegration =(e) => {
        e.preventDefault()
        //alert('CheckIntegration')
        const cookies = new Cookies();
        axios.get(process.env.REACT_APP_BACKEND_SERVER + '/CheckChannelIntegrated', {
            headers: {
                'Authorization': 'Bearer '+cookies.get('tgsubs_token')
            },
            params : {
                'chat_id' : this.state.channel_name
                
            }
        }).then((res) => {
            console.log(res.data)
            if (res.data.is_integrated) {
                this.props.handleClickFirstStage(e)
            }
            else {
                this.doShowErrorMsg('вы не настроили интеграцию')                                
           }
        })
        
    }

    CheckIntegration =(e) => {
        e.preventDefault()
        //alert('CheckIntegration')
        const cookies = new Cookies();
        axios.get(process.env.REACT_APP_BACKEND_SERVER + '/CheckChannelIntegrated', {
            headers: {
                'Authorization': 'Bearer '+cookies.get('tgsubs_token')
            },
            params : {
                'chat_id' : this.state.channel_name
                
            }
        }).then((res) => {
            console.log(res.data)
            if (res.data.is_integrated) {
                this.handleClickFirstStage(e)
            }
            else {
                this.doShowErrorMsg('вы не настроили интеграцию')                                
           }
        })
        
    }

    ChooseTemplate = (e, tmp_id) => {
        

        
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   tmp_id : tmp_id,
                    
               };
       }, () =>  {
           
       })

       this.handleClickSecondStage(e)

    }

    doShowErrorMsg ( msg) {
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   errorMsg : msg,
                   showErrorMsg : true
               };
       }, () =>  {
           
       })
        setTimeout(() => { 
          
            this.setState((prevState) => {
                return  {
                       ...prevState,
                       errorMsg : null,
                       showErrorMsg : false
                   };
           }, () =>  {
               
           })

        }, 2000)
 
    }
    
    doSave(e) {
        e.preventDefault()
        //alert('CheckIntegration')
        //const cookies = new Cookies();
        console.log(  JSON.stringify(this.state) )
       /*
        axios
            .post(process.env.REACT_APP_BACKEND_SERVER+'/CreatePage/', {
                
                'data' : JSON.stringify(this.state)
                
            }, {
                headers : {
                    'Authorization': 'Bearer '+cookies.get('tgsubs_token')
                }
            } )
            .then(res => {
                if (res.data.status == 'ok') {
                    window.location.href = '/pages'
                }
            })
            .catch(err => {
            console.log(err);
            })

         */ 
    }

    updatePrize(e) {
        const updatedInputValue = e.target.value;
        
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    prize : updatedInputValue,
                    
                
                };
        }, () =>  {
            
        })


    }

    updateHeader (e) {
        const updatedInputValue = e.target.value;
        
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    header_text : updatedInputValue,
                    
                
                };
        }, () =>  {
            
        })
    }

    updateMain(e) {
        const updatedInputValue = e.target.value;
        
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    main_text : updatedInputValue,
                    
                
                };
        }, () =>  {
            
        })
    }
   
    render() {
        return (
            <RedPageComponent 
            doSave={this.doSave}
            big_img_src={this.state.big_img_src}
        small_img_src={this.state.small_img_src}
        selected_file={this.state.selected_file}
        prize={this.state.prize}
        header_text={this.state.header_text}
        main_text={this.state.main_text}
        btnText={this.state.btnText}
            />
        )
        
        
    }
}

export default withRouter(RedPage);